import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Comments from '@src/pc/components/Comments';
import styles from './index.css';
import Header from './Header';

const Layout = ({ content }) => {
    const { event, params } = content;
    const { subjectId } = params;

    return (
        <div className={styles.layout}>
            <Header content={event} />
            <Comments subjectId={subjectId} />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
